export default {
    methods: {
        formatMoney (amount, accounting = false, decimalCount = 2, decimal = ".", thousands = ",") {
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? (accounting ? "(" : "-") : "";
                const negativeEndSign = accounting && amount < 0  ? ')' : '';

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;

                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "") + negativeEndSign;
            } catch (e) {
                console.log(e)
            }
        },
        formatDate (date_string) {
            if(!date_string){
                return '';
            }
            let cleaned_date_string = date_string.replace(/-/g, '/').replace(/[[.]+[0-9]*]*$/g, '');
            let currentDate = new Date(cleaned_date_string);

            let date = currentDate.getDate();
            let month = currentDate.getMonth(); //Be careful! January is 0 not 1
            let year = currentDate.getFullYear();

            return date + " " + MonthNames[month] + " " + year;
        },
    }
}